import { useEffect } from 'react';
import { useMatches, type Params } from 'react-router';

export const APP_NAME = 'MGRV Core Admin';

/** 라우트 handle — 브라우저 탭·방문 기록에 보일 화면 이름. 경로 값이 필요하면 함수로 준다. */
export interface RouteHandle {
  title: string | ((params: Params) => string);
}

function titleOf(handle: unknown, params: Params): string | null {
  if (typeof handle !== 'object' || handle === null || !('title' in handle)) {
    return null;
  }
  const { title } = handle as RouteHandle;
  return typeof title === 'function' ? title(params) : title;
}

/** 일치한 라우트 중 가장 안쪽 handle.title을 쓰고, 바깥 title을 " · "로 이어 붙인다 — "일반 · 설정 · MGRV Core Admin". */
export function buildDocumentTitle(matches: { handle: unknown; params: Params }[]): string {
  const parts = matches
    .map((match) => titleOf(match.handle, match.params))
    .filter((title): title is string => Boolean(title))
    .reverse();
  return [...parts, APP_NAME].join(' · ');
}

/** 화면이 바뀔 때마다 document.title을 맞춘다 — 탭 여러 개·방문 기록·스크린리더에서 화면을 구분하게 한다. */
export function useDocumentTitle() {
  const matches = useMatches();
  const title = buildDocumentTitle(matches);
  useEffect(() => {
    document.title = title;
  }, [title]);
}
